var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 53,
    viewBox: "0 0 70 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.6.671a8.685,8.685,0,0,0-9.533,1.917L51.979,5.7l-.4-.817A8.744,8.744,0,0,0,43.75,0h-35A8.79,8.79,0,0,0,0,8.833V44.167A8.792,8.792,0,0,0,8.75,53h35a8.74,8.74,0,0,0,7.827-4.885l.4-.813,3.084,3.109A8.667,8.667,0,0,0,64.6,52.324,8.824,8.824,0,0,0,70,44.167V8.833A8.835,8.835,0,0,0,64.6.671Zm-3.347,43.5L52.5,35.333H48.125L43.75,44.167h-35V8.833h35l4.375,8.833H52.5l8.75-8.833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo2);
export default __webpack_public_path__ + "static/media/video_2.daea52c24a23bfed4f1b47bc5bd67462.svg";
export { ForwardRef as ReactComponent };